import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const WaterIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="water" ref={ref} {...props}>
      <path d="M11.29,2.55c-.45.52-5.55,6.67-5.55,12.15,0,4.35,2.36,7.05,6.15,7.05s6.15-2.7,6.15-7c0-5.48-5.1-11.63-5.55-12.15a.72.72,0,0,0-1.2,0Zm.6,17.7c-2.91,0-4.65-2.08-4.65-5.55,0-4,3.3-8.74,4.65-10.5,1.35,1.75,4.65,6.45,4.65,10.5C16.54,18.17,14.8,20.25,11.89,20.25Z" />
    </Icon>
  ),
) as IconWithRender;

WaterIcon.displayName = 'WaterIcon';
WaterIcon.renderIcon = (props) => <WaterIcon {...props} />;
export default WaterIcon;
